import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const InAppClose = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3201 9.18994V4.68994C19.3201 4.39157 19.2015 4.10542 18.9906 3.89445C18.7796 3.68347 18.4934 3.56494 18.1951 3.56494H4.69507C4.3967 3.56494 4.11055 3.68347 3.89957 3.89445C3.68859 4.10542 3.57007 4.39157 3.57007 4.68994V17.0649C3.57007 17.3633 3.68859 17.6495 3.89957 17.8604C4.11055 18.0714 4.3967 18.1899 4.69507 18.1899H9.19507"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.57007 6.93994H19.3201"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7 15.6997C11.7 16.2907 11.8163 16.8758 12.0425 17.4218C12.2686 17.9677 12.6001 18.4638 13.018 18.8817C13.4358 19.2996 13.9319 19.631 14.4779 19.8572C15.0238 20.0833 15.609 20.1997 16.2 20.1997C16.7909 20.1997 17.3761 20.0833 17.922 19.8572C18.468 19.631 18.9641 19.2996 19.3819 18.8817C19.7998 18.4638 20.1313 17.9677 20.3574 17.4218C20.5836 16.8758 20.7 16.2907 20.7 15.6997C20.7 15.1088 20.5836 14.5236 20.3574 13.9776C20.1313 13.4317 19.7998 12.9356 19.3819 12.5177C18.9641 12.0999 18.468 11.7684 17.922 11.5422C17.3761 11.3161 16.7909 11.1997 16.2 11.1997C15.609 11.1997 15.0238 11.3161 14.4779 11.5422C13.9319 11.7684 13.4358 12.0999 13.018 12.5177C12.6001 12.9356 12.2686 13.4317 12.0425 13.9776C11.8163 14.5236 11.7 15.1088 11.7 15.6997V15.6997Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.8875 14.0122L14.5125 17.3872"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.5125 14.0122L17.8875 17.3872"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
